import AQUAIcon from 'assets/icons/blue-icon.svg'
import CAKEIcon from 'assets/icons/CAKE.svg'
import ETHIcon from 'assets/icons/ETH.svg'
import BTCBIcon from 'assets/icons/BTCB.svg'
import BUSDIcon from 'assets/icons/BUSD.png'
import BNBIcon from 'assets/icons/BNB.png'
import USDTIcon from 'assets/icons/USDT.svg'
import VAIIcon from 'assets/icons/VAI.png'
import USTIcon from 'assets/icons/UST.png'
import USDCIcon from 'assets/icons/USDC.svg'
import TUSDIcon from 'assets/icons/TUSD.svg'
import DAIIcon from 'assets/icons/DAI.svg'
import FourBeltIcon from 'assets/icons/4belt-icon.png'
import GAMMAIcon from 'assets/icons/gamma-icon.png'
import LUNAIcon from 'assets/icons/LUNA.png'
import LINKIcon from 'assets/icons/LINK.svg'
import DOTIcon from 'assets/icons/DOT.svg'
import ADAIcon from 'assets/icons/ADA.svg'
import DOGEIcon from 'assets/icons/DOGE.svg'
import XRPIcon from 'assets/icons/XRP.svg'
import UNIIcon from 'assets/icons/Uni.svg'
import LTCIcon from 'assets/icons/LTC.svg'
import XVSIcon from 'assets/icons/XVS.svg'
import FRAXIcon from 'assets/icons/FRAX.svg'
import MBOXIcon from 'assets/icons/MOBX.png'
import MATICIcon from 'assets/icons/MATIC.svg'
import SOLIcon from 'assets/icons/SOL.svg'
import AUSTIcon from 'assets/icons/aUST.png'
import AVAX from 'assets/icons/AVAX.svg'
import FTMIcon from 'assets/icons/FTM.svg'
import AtomIcon from 'assets/icons/atom_icon.png'
import whustIcon from 'assets/icons/whust_icon.svg'
import stableSwap3GIcon from 'assets/icons/3g-icon.png'
import stableSwapIcon from 'assets/icons/stable-swap-icon.png'
import hayIcon from 'assets/icons/hay_icon.png'
import bnbxIcon from 'assets/icons/BNBx.png'
import gammaInfinityIcon from 'assets/icons/gamma_infinity.png'
import aquaInfinityIcon from 'assets/icons/aqua_inf.png'
import ankrBNB from 'assets/icons/ankrBNB.png'

export const getTokenIcon = (tokenName: string) => {
    const token = tokenName.toLowerCase()

    if (token === 'aqua') {
        return AQUAIcon
    }
    if (token === 'gamma') {
        return GAMMAIcon
    }
    if (token === 'luna') {
        return LUNAIcon
    }
    if (token === 'acac') {
        return AQUAIcon
    }
    if (token === 'cake') {
        return CAKEIcon
    }
    if (token === 'eth') {
        return ETHIcon
    }
    if (token === 'btcb') {
        return BTCBIcon
    }
    if (token === 'btc') {
        return BTCBIcon
    }
    if (token === 'busd') {
        return BUSDIcon
    }
    if (token === 'bnb') {
        return BNBIcon
    }
    if (token === 'wbnb') {
        return BNBIcon
    }
    if (token === 'cake') {
        return CAKEIcon
    }
    if (token === 'usdt') {
        return USDTIcon
    }
    if (token === 'usdc') {
        return USDCIcon
    }
    if (token === 'dai') {
        return DAIIcon
    }
    if (token === 'ust') {
        return USTIcon
    }
    if (token === 'tusd') {
        return TUSDIcon
    }
    if (token === 'vai') {
        return VAIIcon
    }
    if (token === '4belt') {
        return FourBeltIcon
    }
    if (token === 'link') {
        return LINKIcon
    }
    if (token === 'dot') {
        return DOTIcon
    }
    if (token === 'xrp') {
        return XRPIcon
    }
    if (token === 'doge') {
        return DOGEIcon
    }
    if (token === 'ada') {
        return ADAIcon
    }
    if (token === 'ltc') {
        return LTCIcon
    }
    if (token === 'uni') {
        return UNIIcon
    }
    if (token === 'xvs') {
        return XVSIcon
    }
    if (token === 'frax') {
        return FRAXIcon
    }
    if (token === 'mbox') {
        return MBOXIcon
    }
    if (token === 'matic') {
        return MATICIcon
    }
    if (token === 'sol') {
        return SOLIcon
    }
    if (token === 'aust') {
        return AUSTIcon
    }
    if (token === 'avax') {
        return AVAX
    }
    if (token === 'ftm') {
        return FTMIcon
    }
    if (token === 'atom') {
        return AtomIcon
    }
    if (token === 'xrp') {
        return XRPIcon
    }
    if(token === 'whust'){
        return whustIcon
    }
    if(token === '3glp'){
        return stableSwap3GIcon
    }
    if(token === 'busd-usdt-usdc'){
        return stableSwap3GIcon
    }
    if(token === '3g'){
        return stableSwapIcon
    }
    if(token === 'hay'){
        return hayIcon
    }
    if(token == 'bnbx'){
        return bnbxIcon
    }
    if(token == 'gamma infinity'){
        return gammaInfinityIcon
    }
    if(token == 'aqua infinity'){
        return aquaInfinityIcon
    }
    if(token == 'ankrbnb'){
        return ankrBNB
    }
}
